import * as types from './officeDetail.types';

export const getOfficeDetailRequest = params => ({ type: types.GET_OFFICE_DETAIL_REQUEST, params });
export const getOfficeDetailSuccess = data => ({ type: types.GET_OFFICE_DETAIL_SUCCESS, data });
export const getOfficeDetailFailure = error => ({ type: types.GET_OFFICE_DETAIL_FAILURE, error });

export const getSimilarListRequest = params => ({ type: types.GET_SIMILAR_LIST_REQUEST, params });
export const getSimilarListSuccess = data => ({ type: types.GET_SIMILAR_LIST_SUCCESS, data });
export const getSimilarListFailure = error => ({ type: types.GET_SIMILAR_LIST_FAILURE, error });
